import { render, staticRenderFns } from "./ViewPhoto.vue?vue&type=template&id=3a37fe44&scoped=true"
import script from "./ViewPhoto.vue?vue&type=script&lang=js"
export * from "./ViewPhoto.vue?vue&type=script&lang=js"
import style0 from "./ViewPhoto.vue?vue&type=style&index=0&id=3a37fe44&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37fe44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a37fe44')) {
      api.createRecord('3a37fe44', component.options)
    } else {
      api.reload('3a37fe44', component.options)
    }
    module.hot.accept("./ViewPhoto.vue?vue&type=template&id=3a37fe44&scoped=true", function () {
      api.rerender('3a37fe44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassOverviewDetail/components/StudentStatusRecord/components/ViewPhoto.vue"
export default component.exports